import { Serializer } from "survey-core";
import { PostalCodeValidator } from "../validators/PostalCodeValidator";

/**
 * Register custom SurveyJS validators.
 *
 * The `postalcode` validator centralizes the postal-code regex (per country) so
 * forms only need `{ "type": "postalcode", "country": "NL" }`.
 *
 * Registering only the `postalcodevalidator` class is sufficient: SurveyJS
 * deserializes a validator's JSON `type` by appending the `validators` property's
 * `classNamePart` ("validator") when it is not already present, so
 * `{ "type": "postalcode" }` resolves to the `postalcodevalidator` class. This is
 * the same convention used by the built-in validators (JSON `regex` ->
 * `regexvalidator`, `expression` -> `expressionvalidator`, ...). See survey-core
 * `JsonMetadataClass`/`getObjType` (append when `res.indexOf(classNamePart) < 0`).
 * `PostalCodeValidator.test.ts` locks this behaviour in with a regression test.
 */
export const registerValidators = () => {
  Serializer.addClass(
    "postalcodevalidator",
    [{ name: "country", default: "NL" }],
    () => new PostalCodeValidator(),
    "surveyvalidator",
  );
};
